import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { 
	adminNewListedFormRowData, 
	adminNewListedFormTitle,
	adminNewListedTableData, 
	adminNewListedFormIsLoading, 
	adminNewListedSkuMappingData,
	adminNewListedFormIsSkuMappingData,
	brandForm, 
	skuForm, 
	siteForm,
} from "../@signals"


export default function useAdminNewListedForm(dataRow={}) {
	const { showToast } = useToast()

	const handleOpenForm = useCallback(() => batch(() => {
		adminNewListedFormTitle.value = dataRow.productName
		brandForm.value = dataRow.brandID ?? null
		skuForm.value = dataRow.skuID ?? null
		siteForm.value = { siteID: dataRow.siteID, siteCountry: dataRow.country }
		adminNewListedFormRowData.value = dataRow
	}), [JSON.stringify(dataRow)])

	const handleSendToBack = useCallback((extraData={}, callback={}) => {
		showToast.promise(postSubmit(`${BACKEND_APIS.ADMIN}/product-review/update-mapping`, {
			item: {...dataRow, ...adminNewListedFormRowData.value}, mapping: { ...dataRow, ...extraData}
		}), callback)
	}, [JSON.stringify(dataRow)])

	const handleUpdate = useCallback(() => {
		const myID = adminNewListedFormRowData.value.id
		adminNewListedFormIsLoading.value = myID

		handleSendToBack({
			...adminNewListedFormRowData.value,
			brandID: brandForm.value || null,
			skuID: Array.isArray(skuForm.value) ? null : skuForm.value,
			qa: true, validated: true
		},  {
			onSuccess: newRow => {
				if (!adminNewListedFormIsSkuMappingData.value)
					adminNewListedTableData.value = adminNewListedTableData.value.map(row => row.id === myID ? newRow : row)
				else
					adminNewListedSkuMappingData.value = adminNewListedSkuMappingData.value.map(row => row.id === myID ? newRow : row)
				return 'Data loaded'
			},
			onFinish: () => adminNewListedFormIsLoading.value = null
		})
	}, [JSON.stringify(dataRow)])

	return {
		isOpenEditDrawer: adminNewListedFormRowData.value.id === dataRow.id,
		isLoadingDrawer: adminNewListedFormIsLoading.value === dataRow.id,
		handleOpenForm,
        handleSendToBack,
        handleUpdate
	}
}